import { render } from "./AddNewMsgType.vue?vue&type=template&id=e2b9c7c8&scoped=true&ts=true"
import script from "./AddNewMsgType.vue?vue&type=script&lang=ts"
export * from "./AddNewMsgType.vue?vue&type=script&lang=ts"

import "./AddNewMsgType.vue?vue&type=style&index=0&id=e2b9c7c8&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b9c7c8"]])

export default __exports__